/* eslint-disable no-unused-vars */
import {
  Divider, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText,
} from '@material-ui/core';
import moment from 'moment';
// @ts-ignore
import pt from 'moment/locale/pt-br';
import React, { useEffect, useState } from 'react';
import IconDelete from '@material-ui/icons/Delete';
import IconEmail from '@material-ui/icons/Email';
import { toast } from 'react-toastify';
import { useSelector, RootStateOrAny } from 'react-redux';
import Container from '../../components/container';
import { useStyles } from '../../constants/styles';
import axios from '../../services/axiosServicesAgendamentos';
import { ContainerLoading } from './styles';
import { UserState } from '../../interfaces';
import LoadingCommon from '../../components/LoadingCommon';

interface ScheduleReservationProps {
    idAgenda: string,
    dataInicioAgenda: string,
    dataEncerramentoAgenda: string,
    nomeAgenda: string,
    dataHoraInicioReservaPosicoes: string,
    dataHoraEncerramentoReservaPosicoes: string,
    limiteAgendamentosTurnos: Number,
    bufferEntreTurnos: String,
    ativa: boolean;
}

const ScheduleReservation = () => {
  const classes = useStyles();
  const {
    permissoes,
  } = useSelector<RootStateOrAny, UserState>((state) => state.user);

  const [data, setData] = useState<Array<ScheduleReservationProps>>();
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingSendEmail, setLoadingSendEmail] = useState<boolean>(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setLoading(true);
      const params: {
        PaginaAtual: number;
        TotalItensRetorno: number;
      } = {
        PaginaAtual: 1,
        TotalItensRetorno: 20,
      };
      const response = await axios.get('/admin/agendas/v1', { params });
      const value: Array<ScheduleReservationProps> = response?.data.data;
      setData(value);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const removeAgenda = async (id: string) => {
    try {
      setLoading(true);
      await axios.delete(`/admin/agendas/v1/${id}`);
      setData(data?.filter((item) => item.idAgenda !== id));
      toast.success('Agenda removida com sucesso!');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Não foi possível remover a agenda');
    }
  };
  const handleDate = (date: string): string => {
    const newDate = moment(date).locale('pt-br').format('DD-MM-YYYY, HH:mm');
    return newDate;
  };

  const sendEmail = async (id: string) => {
    try {
      setLoadingSendEmail(true);
      await axios.get(`/admin/agendas/reserva-posicao/v1/relatorio/${id}`);
      setLoadingSendEmail(false);
      toast.success('Solicitação de relatório por e-mail enviada com sucesso!');
    } catch (error) {
      setLoadingSendEmail(false);
      toast.error('Não foi possível realizar sua solicitação, tente novamente!');
    }
  };

  return (
    <Container component="div" maxWidth="lg">
      {loading ? (
        <ContainerLoading>
          <LoadingCommon />
        </ContainerLoading>
      ) : (
        <div style={{ marginTop: 120 }}>
          {
          data?.map((item) => (
            <List key={item.idAgenda} className={classes.root}>
              <ListItem alignItems="flex-start">
                <ListItemText
                  primary={item.nomeAgenda}
                  secondary={(
                    <>
                      {`Início da reserva de posições ${handleDate(item.dataHoraInicioReservaPosicoes)} - fim ${handleDate(item.dataHoraEncerramentoReservaPosicoes)}`}
                    </>
                )}
                />
                <ListItemSecondaryAction>
                  {permissoes?.includes('admin_recurso_download_relatorio_agenda') && (
                  <IconButton disabled={loadingSendEmail} onClick={() => sendEmail(item.idAgenda)}>
                    <IconEmail />
                  </IconButton>
                  )}
                  <IconButton onClick={() => removeAgenda(item.idAgenda)}>
                    <IconDelete />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
              <Divider variant="inset" component="li" />
            </List>
          ))
        }
        </div>
      )}
    </Container>
  );
};
export default ScheduleReservation;
